/* eslint-disable react/forbid-prop-types */
import React from 'react';
import Carousel from 'TMComponents/Carousel';
import LargeCard from 'TMComponents/Cards/LargeCard';
import parseCommonOptions from 'TMComponents/ComponentMapper/parseCommonOptions';
import { array, oneOf } from 'prop-types';

const CardCarousel = ({ indicatorColor, cards }) => {
    const allLargeCards = cards.every(
        (c) => c.__typename === 'DatoCmsCardV2'
    );
    if (!allLargeCards) return null;

    const cardsMapped = cards.map(
        ({ id, __typename, commonOptions, ...rest }) => {
            const common = parseCommonOptions(commonOptions);

            return <LargeCard key={id} {...rest} commonOptions={common} />;
        }
    );

    return (
        <Carousel indicatorColor={indicatorColor}>{cardsMapped}</Carousel>
    );
};

export default CardCarousel;

CardCarousel.propTypes = {
    cards: array.isRequired,
    indicatorColor: oneOf(['dark', 'light'])
};
